import {z as zod} from "zod";

export type AmaronSpecificBehaviourWorkspaceCapabilityConfiguration = Record<string, never>;

export const amaronSpecificBehaviourWorkspaceCapabilityConfigurationValidator: zod.ZodType<AmaronSpecificBehaviourWorkspaceCapabilityConfiguration> = zod.strictObject({});
